import React from 'react';

import {
  CloseIcon,
  Container,
  Content,
  Header,
  Icon,
  Item,
  Left,
  Title,
  SectionTitle,
  ItemIcon,
  ReceiptIcon,
} from './styles';

type SortModalProps = {
  close: () => void;
  bankslips: any;
  sort: (bankSlips: any, param: string) => void;
};

const SortModal: React.FC<SortModalProps> = ({ close, bankslips, sort }) => {
  return (
    <Container>
      <Header>
        <Left>
          <Title>Ordenar</Title>
        </Left>
        <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
      </Header>
      <Content>
        <Item>
          <SectionTitle>
            <ItemIcon
              className="mdi mdi-calendar-blank-outline"
              aria-hidden="true"
            />
            Data
          </SectionTitle>
          <div>
            <Icon
              className="mdi mdi-arrow-up ml-2"
              onClick={() => sort(bankslips, 'maiorData')}
            />
            <Icon
              className="mdi mdi-arrow-down ml-2"
              onClick={() => sort(bankslips, 'menorData')}
            />
          </div>
        </Item>

        <Item>
          <SectionTitle>
            <div className="d-flex flex-row align-items-center">
              <ItemIcon className="mdi mdi-currency-usd" aria-hidden="true" />
              Valor
            </div>
          </SectionTitle>
          <div>
            <Icon
              className="mdi mdi-arrow-up ml-2"
              onClick={() => sort(bankslips, 'maiorValor')}
            />
            <Icon
              className="mdi mdi-arrow-down ml-2"
              onClick={() => sort(bankslips, 'menorValor')}
            />
          </div>
        </Item>

        <Item>
          <SectionTitle>
            <div className="d-flex flex-row align-items-center">
              <ReceiptIcon aria-hidden="true" />
              Nº da Nota
            </div>
          </SectionTitle>
          <div>
            <Icon
              className="mdi mdi-arrow-up ml-2"
              onClick={() => sort(bankslips, 'notaMaior')}
            />
            <Icon
              className="mdi mdi-arrow-down ml-2"
              onClick={() => sort(bankslips, 'notaMenor')}
            />
          </div>
        </Item>
      </Content>
    </Container>
  );
};

export default SortModal;
